<div class=" scrollbar app">
    <div class="pad15 border mb15">
        <div class="row">
            <div class="col-12">
                <div class="af-form-group">
                    <label translate class="mbold">lblWarrantyDocument</label>
                    <div class="lbl-info mt-3">
                        <button class="btn btn-sm btn-primary mr-2" (click)="DownloadWarrantyDocument()" [disabled]="displayDownloadSection"
                            aria-label="Center Align" translate>
                            <em class="fas fa-download mr-2"></em>lblDownload</button>

                        <ng-container
                            *ngIf="(pendingSignDocument?.docSignUrl && !isWarrantyChanged) || isWarrantyDocumentSigned || displayDownloadSection || 
                            this.editAppointmentService.appointmentDetails.isFromArchive; else loadElseGenerateBtn">
                            <button class="btn btn-sm btn-primary mr-2" disabled aria-label="Center Align" translate>
                                <em class="fas fa-file-signature mr-2"></em>lblGenerateDocumentLink</button>
                            <button class="btn btn-sm btn-primary mr-2" disabled aria-label="Center Align" translate>
                                <em class="fas fa-file-signature mr-2"></em>lblSendToCustomer</button>
                        </ng-container>
                        <ng-template #loadElseGenerateBtn>
                            <button class="btn btn-sm btn-primary mr-2" (click)="SendWarrantyDocument(false)"
                                aria-label="Center Align" translate>
                                <em class="fas fa-file-signature mr-2"></em>lblGenerateDocumentLink</button>
                            <button class="btn btn-sm btn-primary mr-2" (click)="SendWarrantyDocument(true)"
                                aria-label="Center Align" translate>
                                <em class="fas fa-file-signature mr-2"></em>lblSendToCustomer</button>
                        </ng-template>

                        <ng-container *ngIf="isWarrantyDocumentSigned; else loadElseSignDownloadBtn">
                            <button class="btn btn-sm btn-primary mr-2" (click)="DownloadSignedWarrantyDocument()"
                                aria-label="Center Align" translate>
                                <em class="fas fa-download mr-2"></em>lblDownloadSignedDocument</button>
                        </ng-container>
                        <ng-template #loadElseSignDownloadBtn>
                            <button class="btn btn-sm btn-primary mr-2" disabled aria-label="Center Align" translate>
                                <em class="fas fa-download mr-2"></em>lblDownloadSignedDocument</button>
                        </ng-template>
                    </div>
                </div>
                <div class="af-form-group mt-3" *ngIf="pendingSignDocument?.docSignUrl && !isWarrantyChanged && !isWarrantyDocumentSigned">
                    <label translate class="mbold">lblSignUrlCustomer</label>
                    <div class="lbl-info">
                        <span>{{pendingSignDocument.docSignUrl}}</span>
                        <button class="btn btn-link ml-2" (click)="copyDocumentSignUrl()" placement="top"
                            ngbTooltip="Copy Url." aria-label="Center Align">
                            <em class="fas fa-copy fa-lg"></em>
                        </button>
                    </div>
                </div>
                <ng-container *ngIf="rejectedDocuments?.length > 0">
                    <div class="af-form-group mt-3">
                        <label translate class="mbold">lblRejectionReason</label>
                        <ng-container *ngFor="let doc of rejectedDocuments; let i=index">
                            <div class="lbl-info comment-box mt-2" *ngIf="doc.rejectedReason">
                                <div class="d-flex flex-row justify-content-between">
                                    <span class="mbold">{{doc.rejectedUser}}</span>
                                    <span>{{getDate(doc.rejectedTime) | date:'short'}}</span>
                                </div>
                                <span>{{doc.rejectedReason}}</span>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
<div class="p-3 bg-light pp-footer-top-brdr">
    <div class="d-flex flex-sm-row flex-column justify-content-end">
        <a (click)="OnClose()" type="reset" class="btn btn-secondary btn-lg" translate>
            <em class="far fa-times-circle font16 align-top mr-2"></em> lblCancel</a>
    </div>
</div>